import React, { FC, ReactNode, memo } from 'react'
import { IonModal, IonContent, IonHeader, IonFooter } from '@ionic/react'
import { classNames } from '@dt/fe-utils'
import './index.scss'

export interface IConfirmModalProps {
  className?: string;
  title?: string;
  canClose?: boolean;
  confirmText?: ReactNode;
  children?: ReactNode;
  cancelText?: ReactNode;
  isLight?: boolean;
  reject?: (isCancle: boolean) => void;
  resolve?: () => void;
}

const ConfirmModal: FC<IConfirmModalProps> = (props) => {
  const { children, className, title = '', confirmText = i18n.t('common.ok'), cancelText, isLight, canClose, reject, resolve } = props

  const handleRejectF = () => {
    reject(false)
  }

  const handleRejectT = () => {
    reject(true)
  }

  const handleConfirm = () => {
    resolve()
  }

  return (
    <IonModal
      isOpen
      cssClass={classNames('confirm-modal', className)}
      backdropDismiss
      showBackdrop
      onDidDismiss={handleRejectF}
    >
      <IonHeader>
        <div className='modal-title'>{title}</div>
        {
          !!canClose && (
            <i
              className='iconfont icon-close' data-cypid='confirmModalClose' onClick={handleRejectF}
            >
            </i>
          )
        }
      </IonHeader>
      <IonContent>
        <div className='ion-content-wrap'>
          {
            children
          }
        </div>
      </IonContent>
      <IonFooter>
        {
          cancelText ? (
            <div className='footer-btn'>
              <div
                className='cancel'
                data-cypid='confirmModalCancel'
                onClick={handleRejectT}
              >{cancelText}
              </div>
              <div
                data-cypid='confirmModalConfirm'
                onClick={handleConfirm}
                className='confirm'
              >{confirmText}
              </div>
            </div>
          ) : (
            <div
              data-cypid='confirmModalConfirm'
              className='footer-btn'
              onClick={handleConfirm}
            >
              <div className={isLight ? 'confirm' : 'cancel'}>{confirmText}</div>
            </div>
          )
        }
      </IonFooter>
    </IonModal>
  )
}

export default memo(ConfirmModal)
